import React from 'react'
import { serviceDetails } from '../../../content/site'

// Rebuilt on the new design (Task 8) - see aligners.jsx for the full rationale (shared by
// all six service files) and the SERVICE PAGES banner in src/css/site/site.css for the CSS.
// `id='dentures'` is new (task-8 brief - consistent style with the three existing anchor
// ids, not previously present).
const Partialdenter = () => {
  const s = serviceDetails.services.find((x) => x.key === 'dentures')
  return (
    <section id={s.id} className={`section service-detail${s.alt ? ' is-alt' : ''}`}>
      <div className="container service-detail-inner">
        <div className="service-detail-copy">
          <h2 className="section-title">{s.title}</h2>
          <p className="section-sub service-detail-desc">
            {s.paragraph.map((line, i) => (
              <React.Fragment key={i}>
                {i > 0 && <br />}
                {line}
              </React.Fragment>
            ))}
          </p>
        </div>
        <div className="service-detail-photos">
          {s.images.map((img, i) => (
            <img key={i} src={img.src} alt={img.alt} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Partialdenter
